import type { BlogFaq } from "@/lib/blog-types";

export function FaqAccordion({ faqs }: { faqs: BlogFaq[] }) {
  if (!faqs?.length) return null;
  return (
    <div className="divide-y divide-border rounded-2xl border border-border bg-card">
      {faqs.map((f) => (
        <details key={f.q} className="group p-5">
          <summary className="flex cursor-pointer list-none items-center justify-between gap-4 font-semibold text-primary">
            {f.q}
            <span className="text-xl leading-none text-primary/50 transition-transform group-open:rotate-45">+</span>
          </summary>
          <p className="mt-3 text-sm text-foreground/75">{f.a}</p>
        </details>
      ))}
    </div>
  );
}
